
import { ERP } from '../_base/endpoint';
import axios from 'axios';

import global from '../../common/utility/global';

class cajaAperturaService {

    /******* QUERIES ******/

    async listar() {
        const response = await axios
            .get(`${ERP}tesoreria/centro-costo`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };


    async paginacion(filter) {
        const response = await axios
            .get(`${ERP}tesoreria/caja-apertura/paginacion?${global.formatParameter(filter)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async obtenerResumenId(id) {
        const response = await axios
            .get(`${ERP}tesoreria/caja-apertura/resumen/${id}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async obtenerPorId(id) {
        const response = await axios
            .get(`${ERP}tesoreria/caja-apertura/${id}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async Getcorrelativo() {
        const response = await axios
            .get(`${ERP}tesoreria/caja-apertura/correlativo`)
            .then(response => { 
                return response.data; 
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };


    async Getefectivo() {
        const response = await axios
            .get(`${ERP}tesoreria/caja-apertura/efectivo`)
            .then(response => { 
                return response.data; 
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };






    async excel(filter) {
        const response = await axios
            .get(`${ERP}tesoreria/caja-apertura/excel?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async pdf(filter) {
        const response = await axios
            .get(`${ERP}tesoreria/caja-apertura/pdf?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    
    async pdfPrint(id) {
        const response = await axios
            .get(`${ERP}tesoreria/caja-apertura/resumen/pdf?id=${id}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async pdfTicket(id) {
        const response = await axios
            .get(`${ERP}tesoreria/caja-apertura/resumen/ticket?id=${id}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };
    /******* TRANSACCIONES ******/

    async registrar(data) {
        const response = await axios
            .post(`${ERP}tesoreria/caja-apertura`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

    async modificar(data) {
        const response = await axios
            .put(`${ERP}tesoreria/caja-apertura`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

    async eliminar(Id) {
        const response = await axios
            .put(`${ERP}tesoreria/caja-apertura/eliminar`, Id)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

    
    async activar(data) {
        const response = await axios
            .put(`${ERP}tesoreria/caja-apertura/activar`, data)
            .then(response => { 
                return response; 
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };
    
    async cerrar_arqueo(Id) {
        const response = await axios
            .put(`${ERP}tesoreria/caja-apertura/cerrar`, Id)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

    async registrarCaja_Cierre(data) {
        const response = await axios
            .post(`${ERP}tesoreria/caja-apertura/efectivo`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };


 
}

export default new cajaAperturaService();